module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_3_m2.34086070d05a753873e32b70c072d567.png";